export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: "What areas does R&R House Renovation LLC serve?",
    a: "We're based in Aubrey, TX and work throughout the DFW metroplex — Denton, Frisco, Dallas, Grand Prairie, Arlington, Fort Worth, Lewisville, Garland, and Grapevine, plus the surrounding towns and counties. If you're near any of those, call us and we'll come out.",
  },
  {
    q: "Do you really handle the insurance claim for me?",
    a: "Yes. Insurance claims are one of our specialties. We inspect the damage for free, photograph and document everything, write a line-item scope of loss for your carrier, and meet your adjuster on site so nothing gets missed or undervalued. If the first estimate comes back short, we file a supplement. Then we do the repairs ourselves — one contractor from the claim all the way to the final walkthrough.",
  },
  {
    q: "How much does a project cost?",
    a: "It depends entirely on scope, size, and material selections — a bathroom refresh and a full gut remodel are very different numbers. That's why every estimate we give is free, written, and itemized, so you can see exactly what you're paying for. Roof and storm damage inspections are free as well.",
  },
  {
    q: "What kinds of damage restoration do you handle?",
    a: "Water, fire, and storm damage. That covers burst pipes and freeze damage, roof leaks, flooding, hail and wind damage, and fire, soot, and smoke remediation. We handle the emergency response and drying, then the full rebuild — framing, drywall, flooring, paint, cabinets, and roofing.",
  },
  {
    q: "Are you licensed and insured?",
    a: "R&R House Renovation LLC is a registered Texas limited liability company, and we carry insurance on our work. We're happy to provide documentation before your project starts.",
  },
  {
    q: "What are your hours?",
    a: "We're open Monday through Saturday, 7:00 AM to 6:00 PM. For active water or storm damage where every hour counts, call us at (936) 371-1087 and we'll do our best to get someone out fast.",
  },
  {
    q: "Do you offer any discounts?",
    a: "Yes. Refer a friend and you get 10% off your next project with us, and the person you referred gets 5% off their first project. It's our way of saying thank you — most of our work comes from people passing our name along.",
  },
  {
    q: "Do you do small jobs, or only full renovations?",
    a: "Both. We take on single-room paint jobs, a bathroom tile shower, a driveway pour, or a leak repair just as seriously as a whole-home renovation. If it falls under painting, flooring, concrete, roofing, carpentry, or remodeling, ask us.",
  },
  {
    q: "How long will my project take?",
    a: "A bathroom typically runs two to four weeks, a kitchen four to eight, and whole-home renovations longer depending on scope. Restoration timelines depend on how fast the insurance approval comes through. You'll get a realistic schedule in writing before we start — and we'll tell you if something changes.",
  },
  {
    q: "Do you speak Spanish?",
    a: "Yes — we serve customers in both English and Spanish. Sí, hablamos español. Comuníquese con nosotros al (936) 371-1087.",
  },
];
